import React from 'react';
import EmailNotificationComponent from 'module/SmsBlast/components/EmailNotification';

export default function EmailNotification() {
  return <EmailNotificationComponent />;
}
